<script lang="ts" setup>
import { RouterView } from 'vue-router'
</script>
<template>
  <main class="sbo-app-main-auth-layout" data-testid="sbo-app-main-auth-layout">
    <RouterView />
  </main>
</template>
